/**
 * Category Utils - 叙事分类配置
 */

// 叙事配置
export interface NarrativeConfig {
  id: string
  name: string
  shortName: string
  emoji: string
  color: string
  bgColor: string
  borderColor: string
}

// 叙事分类配置表
export const NARRATIVE_CONFIG: Record<string, NarrativeConfig> = {
  ai_crypto: {
    id: 'ai_crypto',
    name: 'AI & Crypto',
    shortName: 'AI',
    emoji: '🤖',
    color: 'text-purple-800',
    bgColor: 'bg-purple-100',
    borderColor: 'border-purple-200',
  },
  defi: {
    id: 'defi',
    name: 'DeFi',
    shortName: 'DeFi',
    emoji: '💰',
    color: 'text-blue-800',
    bgColor: 'bg-blue-100',
    borderColor: 'border-blue-200',
  },
  infrastructure: {
    id: 'infrastructure',
    name: 'Infrastructure',
    shortName: 'Infrastructure',
    emoji: '🏗️',
    color: 'text-gray-800',
    bgColor: 'bg-gray-100',
    borderColor: 'border-gray-200',
  },
  nft: {
    id: 'nft',
    name: 'NFT',
    shortName: 'NFT',
    emoji: '🎨',
    color: 'text-pink-800',
    bgColor: 'bg-pink-100',
    borderColor: 'border-pink-200',
  },
  rwa: {
    id: 'rwa',
    name: 'RWA',
    shortName: 'RWA',
    emoji: '🏠',
    color: 'text-green-800',
    bgColor: 'bg-green-100',
    borderColor: 'border-green-200',
  },
  stablecoin: {
    id: 'stablecoin',
    name: 'Stablecoin',
    shortName: 'Stablecoin',
    emoji: '💵',
    color: 'text-yellow-800',
    bgColor: 'bg-yellow-100',
    borderColor: 'border-yellow-200',
  },
  regulation_policy: {
    id: 'regulation_policy',
    name: 'Regulation',
    shortName: 'Regulation',
    emoji: '⚖️',
    color: 'text-red-800',
    bgColor: 'bg-red-100',
    borderColor: 'border-red-200',
  },
  meme_culture: {
    id: 'meme_culture',
    name: 'Meme',
    shortName: 'Meme',
    emoji: '😂',
    color: 'text-orange-800',
    bgColor: 'bg-orange-100',
    borderColor: 'border-orange-200',
  },
  governance: {
    id: 'governance',
    name: 'Governance',
    shortName: 'Governance',
    emoji: '📦',
    color: 'text-indigo-800',
    bgColor: 'bg-indigo-100',
    borderColor: 'border-indigo-200',
  },
  gamefi: {
    id: 'gamefi',
    name: 'GameFi',
    shortName: 'GameFi',
    emoji: '🎮',
    color: 'text-teal-800',
    bgColor: 'bg-teal-100',
    borderColor: 'border-teal-200',
  },
  socialfi_creator: {
    id: 'socialfi_creator',
    name: 'SocialFi',
    shortName: 'SocialFi',
    emoji: '👥',
    color: 'text-cyan-800',
    bgColor: 'bg-cyan-100',
    borderColor: 'border-cyan-200',
  },
  other: {
    id: 'other',
    name: 'Other',
    shortName: 'Other',
    emoji: '📦',
    color: 'text-slate-800',
    bgColor: 'bg-slate-100',
    borderColor: 'border-slate-200',
  },
}

// 获取叙事配置
export function getNarrativeConfig(narrativeId: string): NarrativeConfig {
  return NARRATIVE_CONFIG[narrativeId] || NARRATIVE_CONFIG.other
}

// 获取叙事显示名称
export function getNarrativeDisplayName(narrativeId: string): string {
  const config = NARRATIVE_CONFIG[narrativeId]
  return config ? config.name : narrativeId
}

// 获取叙事短名称
export function getNarrativeShortName(narrativeId: string): string {
  const config = NARRATIVE_CONFIG[narrativeId]
  return config ? config.shortName : narrativeId
}

// 获取叙事 Emoji
export function getNarrativeEmoji(narrativeId: string): string {
  const config = NARRATIVE_CONFIG[narrativeId]
  return config ? config.emoji : '📌'
}

// 获取叙事颜色类
export function getNarrativeColorClass(narrativeId: string): string {
  const config = NARRATIVE_CONFIG[narrativeId]
  if (!config) return 'text-slate-800'
  return `${config.bgColor} ${config.color} ${config.borderColor}`
}

// 所有叙事 ID 列表
export const ALL_NARRATIVE_IDS = Object.keys(NARRATIVE_CONFIG)

export const NARRATIVE_DISPLAY_ORDER = [
  'defi',
  'regulation_policy',
  'infrastructure',
  'stablecoin',
  'rwa',
  'ai_crypto',
  'nft',
  'gamefi',
  'socialfi_creator',
  'governance',
  'meme_culture',
  'other',
]

export function getNarrativeSortRank(narrativeId: string): number {
  const index = NARRATIVE_DISPLAY_ORDER.indexOf(narrativeId)
  return index === -1 ? NARRATIVE_DISPLAY_ORDER.length : index
}
